import * as React from "react"
import { IconProps } from "./IconProps"

export const Edit = (props: IconProps) => {
  const { color = "#161819" } = props

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13" fill="none">
      <path
        d="M0 10.5V13H2.5L9.87333 5.62665L7.37333 3.12666L0 10.5ZM11.8067 3.69332C12.0667 3.43332 12.0667 3.01332 11.8067 2.75332L10.2467 1.19332C9.98667 0.933322 9.56667 0.933322 9.30667 1.19332L8.08667 2.41332L10.5867 4.91332L11.8067 3.69332Z"
        fill={color}
      />
    </svg>
  )
}
